import { mostRecentlyActiveTab } from "./nextTabIdAfterClose";

type Tab = { id: string; lastActiveAt: number | null; started: boolean };

export type ActiveTabAction =
  | { type: "stay" }
  | { type: "navigate"; tabId: string }
  | { type: "create" };

export function resolveActiveTab({
  tabId,
  tabs,
  pendings,
  isAdminView,
  tabsLoaded,
  reopeningTabId,
}: {
  tabId: string | undefined;
  tabs: readonly Tab[];
  pendings: readonly { id: string }[];
  isAdminView: boolean;
  tabsLoaded: boolean;
  reopeningTabId: string | null;
}): ActiveTabAction {
  if (tabId) {
    if (tabs.some((t) => t.id === tabId)) return { type: "stay" };
    if (!isAdminView && pendings.some((p) => p.id === tabId))
      return { type: "stay" };
    if (tabId === reopeningTabId) return { type: "stay" };
  }
  if (!tabsLoaded) return { type: "stay" };
  if (isAdminView) {
    const recent = mostRecentlyActiveTab(tabs);
    return recent ? { type: "navigate", tabId: recent.id } : { type: "stay" };
  }
  // A stale tab id asked for one specific chat, so fall back to the last one
  // used; arriving with no tab id wants a blank chat, and reusing an already
  // blank tab is what keeps repeat visits from piling up empty ones.
  const resume = tabId
    ? mostRecentlyActiveTab(tabs)
    : mostRecentlyActiveTab(tabs.filter((t) => !t.started));
  if (resume) return { type: "navigate", tabId: resume.id };
  const pending = pendings[0];
  if (pending) return { type: "navigate", tabId: pending.id };
  return { type: "create" };
}
